export default __webpack_public_path__ + "static/media/cactus.701178c1.jpg";